import React from 'react';
import { Award, Target, Users, Shield } from 'lucide-react';

const About = () => {
    const boardMembers = [
        {
            name: 'Atul Singh',
            role: 'CEO',
            image: 'https://www.saisamriddhi.in/wp-content/uploads/2022/09/WhatsApp-Image-2024-09-14-at-13.39.35-270x350.jpeg',
            experience: '25+ years in Finance'
        },
        {
            name: 'Sushil Kumar Dhakad',
            role: 'CMD',
            image: 'https://www.saisamriddhi.in/wp-content/uploads/2022/09/WhatsApp-Image-2024-09-14-at-13.47.59-270x350.jpeg',
            experience: '20+ years in Investment'
        },
        {
            name: 'Nikhil Singh Solanki',
            role: 'Managing Director',
            image: 'https://www.saisamriddhi.in/wp-content/uploads/2022/09/WhatsApp-Image-2024-09-14-at-13.48.45-285x370.jpeg',
            experience: '18+ years in Operations'
        },
        {
            name: 'Abhay Nikam',
            role: 'Executive Director',
            image: 'https://www.saisamriddhi.in/wp-content/uploads/2022/09/WhatsApp-Image-2024-09-14-at-13.49.30-286x370.jpeg',
            experience: '22+ years in Finance'
        }
    ];

    return (
        <section id="about" className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                        About Saisamriddhi
                    </h2>
                    <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                        With over 15 years of excellence in financial services, we've helped hundreds of clients
                        achieve their financial goals through personalized strategies and expert guidance.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
                    {/* Content */}
                    <div className="space-y-8">
                        <div className="space-y-6">
                            <h3 className="text-2xl font-bold text-gray-900">
                                Building Wealth, Creating Futures
                            </h3>
                            <p className="text-gray-600 leading-relaxed">
                                Sai Samriddhi Micro Finance Association as an organization was set-up in 2016 and started functioningin
                                the year 2020.
                            </p>
                            <p className='text-gray-600 leading-relaxed'>
                                It is a financial holding company. Sai Samriddhi Micro Finance Association will help
                                you to identify the best of what’s available in the finance in loans, credit, insurance, access to
                                savings accounts, and money transfers are provided to small business owners and entrepreneurs in
                                the underdeveloped parts of India.
                            </p>
                            <p className="text-gray-600 leading-relaxed">
                                The beneficiaries of microfinance are those who do not have access to these traditional financial resources.
                            </p>
                        </div>

                        {/* Values */}
                        <div className="grid grid-cols-2 gap-6">
                            <div className="bg-blue-50 p-6 rounded-xl">
                                <div className="bg-blue-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                                    <Target className="h-6 w-6 text-blue-600" />
                                </div>
                                <h4 className="font-semibold text-gray-900 mb-2">Mission</h4>
                                <p className="text-gray-600 text-sm">Ensure customer delight by providing excellent financial services beyond customer expectation through a well motivated and experience staff within the rules and regulation</p>
                            </div>
                            <div className="bg-green-50 p-6 rounded-xl">
                                <div className="bg-green-100 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                                    <Shield className="h-6 w-6 text-green-600" />
                                </div>
                                <h4 className="font-semibold text-gray-900 mb-2">Trust</h4>
                                <p className="text-gray-600 text-sm">To become the leading financial institution to support persons and the micro, small and medium scale enterprises</p>
                            </div>
                        </div>
                    </div>

                    {/* Image and Stats */}
                    <div className="space-y-8">
                        <div className="relative">
                            <img
                                src="https://images.pexels.com/photos/3184360/pexels-photo-3184360.jpeg?auto=compress&cs=tinysrgb&w=800"
                                alt="Our Team"
                                className="w-full h-80 object-cover rounded-2xl shadow-lg"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
                        </div>

                        {/* Achievement Stats */}
                        <div className="grid grid-cols-2 gap-6">
                            <div className="bg-gradient-to-br from-blue-500 to-blue-600 p-6 rounded-xl text-white">
                                <Award className="h-8 w-8 mb-3" />
                                <div className="text-2xl font-bold mb-1">15+</div>
                                <div className="text-blue-100">Years of Excellence</div>
                            </div>
                            <div className="bg-gradient-to-br from-green-500 to-green-600 p-6 rounded-xl text-white">
                                <Users className="h-8 w-8 mb-3" />
                                <div className="text-2xl font-bold mb-1">500+</div>
                                <div className="text-green-100">Satisfied Clients</div>
                            </div>
                        </div>

                        {/* Certifications */}
                        <div className="bg-gray-50 p-6 rounded-xl">
                            <h4 className="font-semibold text-gray-900 mb-4">Our Certifications</h4>
                            <div className="space-y-2">
                                <div className="flex items-center space-x-2">
                                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                    <span className="text-gray-600">SEBI Registered Investment Advisor</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                    <span className="text-gray-600">Certified Financial Planner (CFP)</span>
                                </div>
                                <div className="flex items-center space-x-2">
                                    <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                                    <span className="text-gray-600">AMFI Registered Mutual Fund Distributor</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Board of Directors Section */}
                <div className="bg-gradient-to-br from-gray-50 to-blue-50 rounded-3xl p-8 lg:p-12">
                    <div className="text-center mb-12">
                        <h3 className="text-3xl font-bold text-gray-900 mb-4">
                            Board of Directors
                        </h3>
                        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                            Meet our experienced leadership team that guides Saisamriddhi towards excellence
                            in financial services and client satisfaction.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                        {boardMembers.map((member, index) => (
                            <div
                                key={index}
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group text-center"
                            >
                                <div className="relative mb-6">
                                    <img
                                        src={member.image}
                                        alt={member.name}
                                        className="w-24 h-24 rounded-full mx-auto object-cover shadow-md group-hover:scale-105 transition-transform duration-300"
                                    />
                                    <div className="absolute inset-0 rounded-full bg-gradient-to-t from-blue-600/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                </div>

                                <h4 className="text-lg font-bold text-gray-900 mb-2">
                                    {member.name}
                                </h4>

                                <div className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium mb-3 inline-block">
                                    {member.role}
                                </div>

                                <p className="text-gray-600 text-sm">
                                    {member.experience}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;